export enum ActionTypes {
  CancelAccount = 'cancelAccount',
  CancelAccountRequest = 'cancelAccount.request',
  CancelAccountSuccess = 'cancelAccount.success',
  CancelAccountFailure = 'cancelAccount.failure',

  ResetCancelAccountInfo = 'resetCancelAccountInfo',
}
